/**
 * @file This javascript file implements the Markup Tools.
 * @author Alex Cui
 * @version 3.0.1-0
 * @copyright (C) Copyright 2007-2014 Software Consulting Services, LLC (SCS).
 */

/**
 * @constructor
 * @desc the main entrance of the markup tool.
 * Call this method and input the markup options.
 * This function will call the markup page.
 * @param {Object} options The markup options
 * @param {String} [options.image=[]] The image link that you want to markup.
 * @param {int} [options.width=618] The width of the image to markup, default value is for the layout page.
 * @param {int} [options.height=792] The height of the image to markup, default value is for the layout page.
 * @param {function} [options.saveFunc=null] A function to call when the user clicks save.
 * @param {boolean} [options.AllowApproved=true] Tag for approve tools.
 * @param {boolean} [options.AllowRejected=true] Reject tools.
 * @param {boolean} [options.AllowArrow=true] Arrow tools.
 * @param {boolean} [options.AllowLine=true] Draw lines on the page
 * @param {boolean} [options.AllowOval=true] Draw oval on the page
 * @param {boolean} [options.AllowPencil=true] Pencil tool.
 * @param {boolean} [options.AllowRectangle=true] Draw a rectangle on the page.
 * @param {boolean} [options.AllowText=true] Text box.
 * @param {boolean} [options.AllowUndo=true] Undo the markup step by step
 * @param {boolean} [options.AllowClear=true] Clear all the markup on the page
 * @param {boolean} [options.AllowSave=true] Commit the markup page.
 * @param {boolean} [options.Transparent=true] Transparent background for blocks.
 * @param {boolean} [options.Black=true] Black background for blocks.
 * @param {boolean} [options.DarkGray=true] DarkGray background for blocks
 * @param {boolean} [options.White=true] White background for blocks.
 * @param {boolean} [options.LightSkyBlue=true]  LightSkyBlue background for blocks.
 * @param {boolean} [options.LightGreen=true] LightGreen background for blocks.
 * @param {boolean} [options.Yellow=true] Yellow background for blocks.
 * @param {boolean} [options.Orange=true] Orange background for blocks.
 * @param {boolean} [options.Tomato=true] Tomato background for blocks.
 * @param {boolean} [options.Purple=true] Purple background for blocks.
 * @param {boolean} [options.AllowWidth=false] Select different width of line.
 * @param {boolean} [options.Opacity=false] Change the opacity of color
 * @param {boolean} [options.Picture=true] Picture template
 * @param {boolean} [options.Story=true] Story template.
 * @param {boolean} [options.Headline=true] Headline template
 * @param {boolean} [options.AllowPointer=true] Pointer tools to resize and drag elements on canvas.
 */
var Annotator = function( options ) {
  var defaultOptions = {
    "image": "",
    "width": 618,
    "height": 792,
    "saveFunc": null,
    "AllowApproved": true,
    "AllowRejected": true,
    "AllowArrow": true,
    "AllowLine": true,
    "AllowOval": true,
    "AllowPencil": true,
    "AllowRectangle": true,
    "AllowText": true,
    "AllowUndo": true,
    "AllowClear": true,
    "AllowSave": true,
    "Transparent": true,
    "Black": true,
    "DarkGray": true,
    "White": true,
    "LightSkyBlue": true,
    "LightGreen": true,
    "Yellow": true,
    "Orange": true,
    "Tomato": true,
    "Purple": true,
    "AllowWidth": false,
    "AllowOpacity": false,
    "AllowPicture": true,
    "AllowStory": true,
    "AllowHeadline": true,
    "AllowPointer": true,

    /**
     * The element that the markup tool is appended to.
     */
    "contentElement": $( "scs_body" )
  };

  this.options = merge( defaultOptions, options );
  this.canvas = null;
  this.canvasContext = null;
  this.canvasRect = null;

  /**
   * Color of lines or background color of blocks.
   * As user could change the opacity of a color,it is
   * the color that will draw on the canvas.
   * @enum {string}
   */
  this.fillColor = "Black";
  this.height = 0;
  this.width = 0;
  this.HSR = 0;
  this.LSR = 0;
  this.WSR = 0;
  this.TSR = 0;
  this.xPos = 0;
  this.yPos = 0;

  /**
   * Div element to show the size of  markup blocks you want to draw.
   * @enum {object}
   */
  this.sizeRect = null;

  /**
   * Name of the markup tool user chooses.
   * @enum {string}
   */
  this.toolName = "";

  /**
   * @enum {Array}
   * @desc Contains the markup log.
   * Every log is a string.
   * Different markup tools have different log format.
   * If you want to add new markup tools, remember add code in GenerateXml
   * method *and GenerateMarkup method
   */
  this.xmlLog = []

  /**
   * Contains the width of lines or border width of blocks.
   * @enum {int}
   */
  this.border = 1;

  /**
   *Contains the color name users choose from color box.
   *@enum {string}
   */
  this.colorName = "Black";

  /**
   * @enum {Array} TargetRegion
   * @desc Contains position information of
   *       draggable and resizable blocks.
   *       if you want to drag or resize any other markup, you can
   *       put the position information in this array by following the
   *       rules in the example. Then add code in GenerateXml method and
   *       GenerateMarkup method.
   *       Except arrow and line tools,
   *       because arrow and line may have angle.
   * @example
   * var positionInfo = [];
   * positionInfo.push(left top corner X position);
   * positionInfo.push(left top corner Y position);
   * positionInfo.push(width);
   * positionInfo.push(height);
   * positionInfo.push(text on the block area);
   * //if no text on this block area,still put empty or random string into it.
   * positionInfo.push(Xmllog.length);//index of this markup in the log array.
   * TargetRegion.push(positionInfo);
   */
  this.targetRegion = [];
  this.canvasInfo = null;

  /**
   *@enum {int} MoveOffSetLeft
   *@desc distance from your mouse to the left of the block you have selected.
   */
  this.moveOffsetLeft = 0;

  /**
   *@enum {int} MoveOffSetTop
   *@desc distance from your mouse to the top of the block you have selected.
   */
  this.moveOffsetTop = 0;

  /**
   * @enum {boolean} TargetStatus
   * @desc If true, the user is moving or resizing a block area, otherwise not.
   * @default false
   */
  this.targetStatus = false;

  /**
   * @enum {int} Target
   * @desc Contains the index of a Target in the TargetRegion array.  If it is
   *       -1, no possible target has been found.  Otherwise the index of this
   *       target in the TargetRegion array.
   * @default -1
   */
  this.target = -1;

  /**
   * @enum {int} TargetLogIndex
   * @desc the index of this target in the markup log.
   */
  this.targetLogIndex = 0;

  /**
   * If true, user is resizing some blocks,otherwise false;
   * @enum {boolean}
   */
  this.resize = false; //the flag for resize

  /**
   * Contains layout page column x position. The first one is the first dotted
   * line.  Right now it is hard coded.
   * @enum {Array}
   */
  this.column = [ "207", "211", "255", "260", "304", "309", "352", "357",
    "400", "405"
  ];

  /**
   *@enum {boolean} snap
   *@desc If true, it will snap to the column, otherwise not.
   *@default true
   */
  this.snap = true;

  /**
   * @enum {int} snapDistance
   * @desc it implys how far it will snap to the column
   * @default 10
   */
  this.snapDistance = 10;

  bindMethods( this );

  this.Load();
}

Annotator.prototype = {

  /**
   * @desc  Set Tool box style
   * @param {object} toolElem The tool element.
   */
  SetToolStyle: function( toolElem ) {
    toolElem.height = "16px";
    toolElem.width = "16px";
    toolElem.style.backgroundColor = "SeaShell";
    toolElem.style.border = "1px solid LightGray";
    toolElem.style.cursor = "default";
    toolElem.style.font = "12px bold Arial";
    toolElem.style.textAlign = "center";
    toolElem.title = toolElem.id + " Tool";
  }, //End of function "SetToolStyle"

  /**
   * @desc Set color box style
   * @param {string} color color ID.
   */
  SetColorStyle: function( Color ) {
    //Color.class="PaletteItem";
    Color.height = "16px";
    Color.width = "16px";
    Color.style.border = "1px solid LightGray";
    Color.style.cursor = "default";
    Color.style.font = "13px bold Arial";
    Color.style.textAlign = "center";
    Color.title = Color.id + " Fill";
  }, //End of function "SetColorStyle"

  /**
   * @desc the main function to parse the markup options and generate the page.
   * @param {Object} options the markup options created by markup function.
   */
  Load: function( options ) {
    var markupToolbarDiv = DIV();

    //Reset the variables.
    this.xmlLog = [];
    this.targetRegion = [];
    this.border = 1;
    this.toolName = "Approved";

    appendChildNodes( this.options.contentElement, markupToolbarDiv );
    this.markupToolbar = new ToolbarManager(
      { "actionFunc": this.selectMarkupTool,
        "contentElement": markupToolbarDiv } );
    this.markupTools = [ { "id": "Approved",
                           "enabled": this.options.AllowApproved,
                           "text": "\u2713",
                           "class": "scs_green" },
                         { "id": "Rejected",
                           "enabled": this.options.AllowRejected,
                           "text": "X",
                           "class": "scs_red" },
                         { "id": "Arrow",
                           "enabled": this.options.AllowArrow,
                           "text": "A" },
                         { "id": "Line",
                           "enabled": this.options.AllowLine,
                           "icon": "BIG_LINE" },
                         { "id": "Oval",
                           "enabled": this.options.AllowOval,
                           "icon": "BIG_OVAL" },
                         { "id": "Pencil",
                           "enabled": this.options.AllowPencil,
                           "icon": "BIG_PENCIL" },
                         { "id": "Rectangle",
                           "enabled": this.options.AllowRectangle,
                           "icon": "BIG_RECTANGLE" },
                         { "id": "Text",
                           "enabled": this.options.AllowText,
                           "text": "T" },
                         { "id": "Picture",
                           "enabled": this.options.AllowPicture,
                           "text": "Pi" },
                         { "id": "Story",
                           "enabled": this.options.AllowStory,
                           "text": "S" },
                         { "id": "Headline",
                           "enabled": this.options.AllowHeadline,
                           "text": "H" },
                         { "id": "Pointer",
                           "enabled": this.options.AllowPointer,
                           "icon": "BIG_POINTER" } ];
    forEach( this.markupTools, this.markupToolbar.addToggleButton );

    this.colorToolbar = new ToolbarManager( { "actionFunc": this.selectFillColor, "scrollFloat": false } );

    this.colors = [ { "id": "transparent",
                      "enabled": this.options.Transparent,
                      "text": "X" },
                    { "id": "Black",
                      "enabled": this.options.Black,
                      "text": "B",
                      "class": "scs_bg_black" },
                    { "id": "DarkGray",
                      "enabled": this.options.DarkGray,
                      "text": "D",
                      "class": "scs_bg_darkgray" },
                    { "id": "White",
                      "enabled": this.options.White,
                      "text": "W",
                      "class": "scs_bg_white" },
                    { "id": "LightSkyBlue",
                      "enabled": this.options.LightSkyBlue,
                      "text": "B",
                      "class": "scs_bg_lightskyblue" },
                    { "id": "LightGreen",
                      "enabled": this.options.LightGreen,
                      "text": "G",
                      "class": "scs_bg_lightgreen" },
                    { "id": "Yellow",
                      "enabled": this.options.Yellow,
                      "text": "Y",
                      "class": "scs_bg_yellow" },
                    { "id": "Orange",
                      "enabled": this.options.Orange,
                      "text": "O",
                      "class": "scs_bg_orange" },
                    { "id": "Tomato",
                      "enabled": this.options.Tomato,
                      "text": "R",
                      "class": "scs_bg_tomato" },
                    { "id": "MediumPurple",
                      "enabled": this.options.Purple,
                      "text": "P",
                      "class": "scs_bg_mediumpurple" } ];

    forEach( this.colors, this.colorToolbar.addToggleButton );

    this.markupToolbar.addSeparator();
    this.markupToolbar.addContent( this.colorToolbar.toolbar.getContentElement() );

    if ( this.options.AllowOpacity ) {
      var label = LABEL( null, "Opacity" );
      var slider = INPUT( { "type": "range",
                            "id": "OpacitySlider",
                            "min": 0,
                            "max": 200,
                            "value": 100 } );
      connect( slider, "onchange", this, this.SelectOpacity );
      appendChildNodes( this.markupToolbar.toolbar.getContentElement(), label, slider );
    } //END OF "IF" CONDITION

    this.actionToolbar = new ToolbarManager( { "actionFunc": this.PerformAction, "scrollFloat": false } );

    var actions = [ { "id": "Undo",
                      "enabled": this.options.AllowUndo,
                      "icon": "BIG_GREENDOWNLEFTARROW" },
                    { "id": "Clear",
                      "enabled": this.options.AllowClear,
                      "icon": "BIG_CANCEL" },
                    { "id": "Save",
                      "enabled": true,
                      "icon": "BIG_DISK" } ];
    forEach( actions, this.actionToolbar.addButton );

    this.markupToolbar.addSeparator();
    this.markupToolbar.addContent( this.actionToolbar.toolbar.getContentElement() );

    if ( this.options.AllowWidth ) {
      this.markupToolbar.addSeparator();
      this.markupToolbar.addContent( LABEL( { "for": "BorderSelect" },
                                            "Width:" ) );
      this.markupToolbar.addSelect( "BorderSelect", range( 1, 10 ), 1 );
    }

    if ( this.options.AllowText ) {
      // Font Select
      this.markupToolbar.addSeparator();
      this.markupToolbar.addContent( LABEL( { "for": "FontSelect" },
                                            "Font:" ) );
      this.markupToolbar.addSelect( "FontSelect",
                                    [ "Arial", "Times New Roman" ],
                                    "Arial" ).setEnabled( false );
      // Font Size Slider
      this.markupToolbar.addSeparator();
      this.markupToolbar.addContent( LABEL( { "for": "FontSize" },
                                            "Size:" ) );
      this.markupToolbar.addSelect( "FontSize",
                                    [ 9, 10, 11, 12, 13, 14, 18, 24, 36, 48,
                                      64, 72, 96, 144, 288 ],
                                    14 );
    } //END OF "IF" CONDITION

    //Draw the canvas
    var div1 = document.createElement( 'div' );
    div1.id = "CanvasWithInfo";
    div1.style.width = this.options.width + "px";
    div1.style.height = this.options.height + "px";
    div1.style.fontSize = "10px";
    div1.style.textAlign = "center";
    this.options.contentElement.appendChild( div1 );

    CanvasWithInfo = document.getElementById( "CanvasWithInfo" );
    var div2 = document.createElement( 'div' );
    div2.id = "CanvasWithBorder";
    div2.style.border = "3px solid DarkGray";
    div2.style.width = this.options.width + "px";
    div2.style.height = this.options.height + "px";
    var div3 = document.createElement( 'div' );
    div3.style.width = this.options.width + "px";
    div3.style.height = this.options.height + "px";
    div1.appendChild( div2 );
    var canvas = document.createElement( 'canvas' );
    canvas.id = "Canvas";
    canvas.width = parseInt( this.options.width ) - 6;
    canvas.height = this.options.height;
    canvas.style.cursor = "crosshair";
    canvas.position = "absolute";
    div3.appendChild( canvas );
    this.xPos = null;
    var div4 = document.createElement( 'div' );
    div4.id = "SizeRect";
    div4.style.backgroundColor = "LightGray";
    div4.style.border = "1px solid Red";
    div4.style.display = "none";
    div4.style.opacity = 0.25;
    div4.style.position = "absolute";
    div3.appendChild( div4 );
    div2.appendChild( div3 );
    var div5 = document.createElement( 'div' );
    div5.id = "XY";
    div1.appendChild( div5 );
    var div6 = document.createElement( 'div' );
    div6.id = "WH";
    div1.appendChild( div6 );
    this.canvas = document.getElementById( 'Canvas' );
    this.canvasContext = this.canvas.getContext( '2d' );
    this.canvasRect = this.canvas.getBoundingClientRect();
    this.sizeRect = document.getElementById( "SizeRect" );

    //Load the Image
    this.DrawImage();

    //Add event Listener
    div3.addEventListener( 'mousedown', this.CanvasMouseDown );
    div3.addEventListener( 'mousemove', this.CanvasMouseMove );
    div3.addEventListener( 'mouseup', this.CanvasMouseUp, false );
    div3.addEventListener( 'dblclick',  this.ChangeContent, false );
  }, //End of function load;

  /**
   * @desc Load the image on the canvas.
   */
  DrawImage: function() {
    //Initial Tool and Color
    this.toolName = "Approved";
    this.colorName = "Black";
    this.SetTool( this.toolName );
    this.SetFillColor( this.colorName );

    this.canvas = document.getElementById( 'Canvas' );
    this.canvasContext = this.canvas.getContext( '2d' );
    this.canvasRect = this.canvas.getBoundingClientRect();
    this.sizeRect = document.getElementById( "SizeRect" );
    this.xPos = null;
    var canvasCtx = this.canvasContext;

    //disable the undo button
    this.actionToolbar.getChild( "Undo" ).setEnabled( false );

    this.canvasContext.font = "18px Arial";
    this.canvasContext.strokeStyle = "Red";
    this.canvasContext.textAlign = "start";
    img = new Image();
    img.src = this.options.image;
    img.id = "PGLPage";
    img.position = "absolute";
    img.onload = function() {
      canvasCtx.drawImage( img, 0, 0 );
    }

    //Write the XML log
    this.imageName = this.options.image.split( "/" ).slice( -1 )[0];
    var xmlrecord = "Image/" + this.imageName;
    this.xmlLog.push( xmlrecord );
  }, //END of function DrawImage;


  /**
   *@desc Handle all the mouse down event happened on the canvas
   *@param {object} event  the page event object handled by the browser.
   */
  CanvasMouseDown: function( event ) {
    if ( !this.targetStatus && ( this.toolName == "Pointer" ) ) {

      var moveX = event.pageX - this.canvasRect.left + 1;
      var moveY = event.pageY - this.canvasRect.top + 1;
      this.target = this.CheckRegion( moveX, moveY );
      if ( this.target >= 0 ) { //selected a Target
        this.SelectTarget();
        this.moveOffsetLeft = moveX - this.targetRegion[ this.target ][ 0 ];
        this.moveOffsetTop = moveY - this.targetRegion[ this.target ][ 1 ];

      }
      return;
    }

    var TempFillColor;
    var TempChr;
    var XC;
    var YC;

    this.xPos = event.pageX; //solve the scrolling bar problem.
    this.yPos = event.pageY;
    this.width = 0;
    this.height = 0;
    if ( ( this.toolName == "Approved" ) || ( this.toolName == "Rejected" ) ) {
      // Draw green check or red X
      TempFillColor = this.fillColor;
      var XmlRecord;

      if ( this.toolName == "Approved" ) {
        //draw the checked tool
        this.canvasContext.fillStyle = "Green";
        this.canvasContext.font = "18px Arial";
        TempChr = "\u2713"; //green check
        XmlRecord = "Approved/";
      } // End of "if" condition
      else {
        //draw the approved tool
        this.canvasContext.fillStyle = "Red";
        this.canvasContext.font = "18px Arial";
        TempChr = "X"; //red X
        XmlRecord = "Rejected/";
      } // End of "else" condition

      this.canvasContext.fillText( TempChr,
        this.xPos - this.canvasRect.left, this.yPos - this.canvasRect.top +
        7 );
      this.canvasContext.fillStyle = TempFillColor;

      //Keep the record of check or cross.
      XmlRecord = XmlRecord + ( this.xPos - this.canvasRect.left ) + "/" +
        ( this.yPos - this.canvasRect.top + 7 );
      this.xmlLog.push( XmlRecord );
      return;
    } // End of "if" condition

    if ( this.toolName == "Pencil" ) {
      // Draw initial dot
      XC = this.xPos - this.canvasRect.left + 1;
      YC = this.yPos - this.canvasRect.top + 1;

      this.canvasContext.strokeStyle = this.fillColor;
      this.canvasContext.lineWidth = this.border;
      this.canvasContext.fillStyle = this.fillColor;
      this.canvasContext.fillRect( XC, YC, 1, 1 );
      this.canvasContext.strokeRect( XC, YC, 1, 1 );
      //write record
      var BeginText = "Pencil/Start";
      this.xmlLog.push( BeginText );
      var record = "Pencil/" + this.fillColor + "/" + this.border;
      this.xmlLog.push( record );
      return;
    } // End of "if" condition

    // Show size rectangle
    this.LSR = this.xPos;
    this.startPosition = this.LSR;
    this.HSR = this.yPos;
    this.WSR = 0;
    this.HSR = 0;
    this.sizeRect.style.left = this.LSR;
    this.sizeRect.style.top = this.HSR;
    this.sizeRect.style.width = this.WSR;
    this.sizeRect.style.height = this.HSR;
    this.sizeRect.style.display = "block";
  }, // End of function "CanvasMouseDown"


  /**
   *@desc Handle all the mouse move event happened on the canvas
   *@param {Object} event page event object
   */
  CanvasMouseMove: function( event ) {
    if ( this.targetStatus ) {
      var moveX = event.pageX - this.canvasRect.left + 1;
      var moveY = event.pageY - this.canvasRect.top + 1;
      if ( this.resize ) {
        //resizing the target
        this.MoveTarget( moveX, moveY );
      } else {
        //draging the target
        this.MoveTarget( moveX - this.moveOffsetLeft, moveY - this.moveOffsetTop );
      }
      return;
    }

    var MaxXY;
    var XC;
    var YC;
    // Show (X,Y)
    document.getElementById( "XY" ).innerHTML =
      "(" +
      ( event.clientX - this.canvasRect.left ) +
      "," +
      ( event.clientY - this.canvasRect.top ) +
      ")";
    if ( this.xPos == null )
      return;

    // Get width and height
    this.width = event.pageX - this.xPos;
    this.height = event.pageY - this.yPos;
    if ( event.shiftKey ) {
      if ( ( this.toolName == "Arrow" ) || ( this.toolName == "Line" ) ) {
        // Constrain to horizontal or vertical
        if ( Math.abs( this.width ) >= Math.abs( this.height ) )
          this.height = 0;
        else
          this.width = 0;
      } else if ( ( this.toolName == "Oval" ) || ( this.toolName ==
          "Rectangle" ) ) {
        // Constrain to circle or square
        MaxXY = Math.max( Math.abs( this.width ), Math.abs( this.height ) );
        if ( this.width >= 0 )
          this.width = MaxXY;
        else
          this.width = -MaxXY;
        if ( this.height >= 0 )
          this.height = MaxXY;
        else
          this.height = -MaxXY;
      }
    } //End of "if" condition

    // Draw pencil line
    if ( this.toolName == "Pencil" ) {
      XC = this.xPos - this.canvasRect.left + 1;
      YC = this.yPos - this.canvasRect.top + 1;
      this.canvasContext.beginPath();
      this.canvasContext.moveTo( XC, YC );
      this.canvasContext.lineTo( XC + this.width, YC + this.height );
      this.canvasContext.stroke();
      this.xPos = this.xPos + this.width;
      this.yPos = this.yPos + this.height;
      //record
      var XmlText = "Pencil/";
      XmlText = XmlText + XC + "/" + YC + "/" + ( XC + this.width ) + "/" +
        ( YC + this.height );
      this.xmlLog.push( XmlText );
      return;
    } // End of "if" condition

    // Re-size size rectangle
    this.WSR = Math.abs( this.width );
    this.HSR = Math.abs( this.height );
    if ( this.width >= 0 )
      this.LSR = this.xPos;
    else
      this.LSR = this.xPos + this.width - 1;
    if ( this.height >= 0 )
      this.TSR = this.yPos;
    else
      this.TSR = this.yPos + this.height - 1;

    //snap to the column when drawing.
    console.log( this.snap );
    if ( this.snap ) {
      //snap to the column
      var index;
      if ( this.LSR == this.startPosition ) {
        //move to right
        var moveDirection = 0;
        for ( index = moveDirection; index < this.column.length; index += 2 ) {
          if ( this.LSR + this.WSR >= parseInt( this.column[ index ] ) + 5 -
            this.snapDistance &&
            this.LSR + this.WSR < parseInt( this.column[ index ] ) + 5 ) {
            this.WSR = parseInt( this.column[ index ] ) + 5 - this.LSR;
          }
        } //End of "For" Loop
      } else {
        //move to left
        var moveDirection = 1;
        for ( index = moveDirection; index < this.column.length; index += 2 ) {
          if ( this.LSR - this.snapDistance <= parseInt( this.column[ index ] ) +
            5 &&
            this.LSR > parseInt( this.column[ index ] ) + 5 ) {
            this.WSR = this.WSR + ( this.LSR - parseInt( this.column[ index ] ) ) +
              5;
            this.LSR = parseInt( this.column[ index ] ) + 5;
          }
        } //End of "For" Loop
      } //End of "if" condition
    } //End of "if" condition
    this.sizeRect.style.width = this.WSR + "px";
    this.sizeRect.style.left = this.LSR + "px";
    this.sizeRect.style.top = this.TSR + "px";
    this.sizeRect.style.height = this.HSR + "px";
    // Show WxH
    document.getElementById( "WH" ).innerHTML = this.WSR + "x" + this.HSR;
  }, // End of function "CanvasMouseMove"

  /**
   *@desc Handles all the mouse up event happened on the canvas.
   *@param {Object} event page event object
   */
  CanvasMouseUp: function( event ) {
    this.actionToolbar.getChild( "Undo" ).setEnabled( true );
    if ( this.targetStatus ) {
      this.ReleaseTarget();
      return;
    }

    var LC;
    var TC;
    var TempStr;
    var XC;
    var YC;
    if ( ( this.toolName == "Approved" ) || ( this.toolName == "Pencil" ) ||
      ( this.toolName == "Rejected" ) ) {
      this.xPos = null;
      if ( this.toolName == "Pencil" ) {
        var XmlText = "Pencil/End";
        this.xmlLog.push( XmlText );
      }
      //write the log
      return;
    } // End of "if" condition

    // Get text
    this.canvasContext.lineWidth = this.border;
    if ( this.toolName == "Text" || this.toolName == "Annotation" || this.toolName ==
      "Picture" ||
      this.toolName == "Story" || this.toolName == "Headline" ) {
      if ( this.toolName == "Text" ) {
        TempStr = prompt( "Text:" );
      } else if ( this.toolName == "Picture" ) {
        TempStr = prompt( "Picture:" );
      } else if ( this.toolName == "Story" ) {
        TempStr = prompt( "Story:" );
      } else if ( this.toolName == "Headline" ) {
        TempStr = prompt( "Headline:" );
      }

      if ( ( TempStr == null ) || ( TempStr == "" ) ) {
        this.sizeRect.style.display = "none";
        document.getElementById( "WH" ).innerHTML = "";
        this.xPos = null;
        return;
      } // End of "if" condition
    } // End of "if" condition

    // Draw shape
    this.sizeRect.style.display = "none";
    XC = this.xPos - this.canvasRect.left + 1;
    YC = this.yPos - this.canvasRect.top + 1;
    LC = this.LSR - this.canvasRect.left + 1;
    TC = this.TSR - this.canvasRect.top + 1;
    if ( ( this.toolName == "Arrow" ) ) {
      if ( this.width == 0 && this.height == 0 ) {
        return;
      }
      this.canvasContext.beginPath();
      var headlen = 10;
      var dx = this.width;
      var dy = this.height;
      var angle = Math.atan2( dy, dx );
      this.canvasContext.moveTo( XC, YC );
      this.canvasContext.lineTo( XC + this.width, YC + this.height );
      this.canvasContext.moveTo( XC + this.width - headlen * Math.cos(
        angle - Math.PI / 6 ), YC + this.height - headlen * Math.sin(
        angle - Math.PI / 6 ) );
      this.canvasContext.lineTo( XC + this.width, YC + this.height );
      this.canvasContext.lineTo( XC + this.width - headlen * Math.cos(
        angle + Math.PI / 6 ), YC + this.height - headlen * Math.sin(
        angle + Math.PI / 6 ) );
      this.canvasContext.strokeStyle = this.fillColor;
      this.canvasContext.stroke();
      //write log
      var XmlRecord = "Arrow/";
      XmlRecord = XmlRecord + XC + "/" + YC + "/" + ( XC + this.width ) +
        "/" + ( YC + this.height ) + "/" + this.fillColor + "/" + this.border;
      this.xmlLog.push( XmlRecord );

    } // End of "if" condition
    else if ( this.toolName == "Line" ) {
      this.canvasContext.beginPath();
      this.canvasContext.moveTo( XC, YC );
      this.canvasContext.lineTo( XC + this.width, YC + this.height );
      this.canvasContext.strokeStyle = this.fillColor;
      this.canvasContext.stroke();
      var XmlRecord = "Line/";
      XmlRecord = XmlRecord + XC + "/" + YC + "/" + ( XC + this.width ) +
        "/" + ( YC + this.height ) + "/" + this.fillColor + "/" + this.border;
      this.xmlLog.push( XmlRecord );
    } //End of "if" condition
    else if ( this.toolName == "Oval" ) {
      this.canvasContext.beginPath();
      this.canvasContext.moveTo( LC + ( this.WSR / 2 ), TC );
      this.canvasContext.quadraticCurveTo( LC + this.WSR, TC,
        LC + this.WSR, TC + ( this.HSR / 2 ) );
      this.canvasContext.quadraticCurveTo( LC + this.WSR, TC + this.HSR,
        LC + ( this.WSR / 2 ), TC + this.HSR );
      this.canvasContext.quadraticCurveTo( LC, TC + this.HSR,
        LC, TC + ( this.HSR / 2 ) );
      this.canvasContext.quadraticCurveTo( LC, TC,
        LC + ( this.WSR / 2 ), TC );
      this.canvasContext.globalAlpha = 0.5;
      this.canvasContext.fillStyle = this.fillColor;
      this.canvasContext.fill();
      this.canvasContext.globalAlpha = 1;
      this.canvasContext.strokeStyle = "Red";
      this.canvasContext.stroke();

      var XmlRecord = "Oval/";
      XmlRecord = XmlRecord + LC + "/" + TC + "/" + this.WSR + "/" + this.HSR +
        "/" + this.fillColor + "/" + this.border;
      this.xmlLog.push( XmlRecord );
    } // End of "if" condition
    else if ( this.toolName == "Text" || this.toolName == "Story" || this.toolName ==
      "Headline" ) {
      this.canvasContext.globalAlpha = 0.5;
      var oldColor = this.fillColor;
      if ( this.toolName == "Headline" ) {
        this.fillColor = "Black";
        this.canvasContext.globalAlpha = 0.5;
      }
      if ( this.toolName == "Story" ) {
        this.fillColor = "LightSkyBlue";
      }
      this.canvasContext.fillStyle = this.fillColor;
      this.canvasContext.fillRect( LC, TC, this.WSR, this.HSR );
      this.canvasContext.globalAlpha = 1;
      this.canvasContext.lineWidth = this.border;
      this.canvasContext.strokeStyle = this.fillColor;
      this.canvasContext.strokeRect( LC, TC, this.WSR, this.HSR );
      var Font = this.markupToolbar.getChild( "FontSelect" ).getValue();
      var Size = this.markupToolbar.getChild( "FontSize" ).getValue();
      var FontSize = parseFloat( Size );
      if ( this.toolName != "Text" ) {
        TempStr = this.toolName + ": " + TempStr;
        FontSize = 18;
      }
      var TextArray = this.TextWrap( this.WSR, TempStr, FontSize );
      this.canvasContext.font = Size + "px " + Font;
      if ( this.toolName != "Text" ) {
        this.canvasContext.font = "18px Arial";
      }
      this.canvasContext.textAlign = "start";
      this.canvasContext.strokeStyle = "red";
      this.canvasContext.lineWidth = 1;
      wrap = 0;
      for ( index = 0; index < TextArray.length; index++ ) {
        this.canvasContext.strokeText( TextArray[ index ], LC + 5, TC +
          FontSize + wrap );
        wrap = wrap + ( FontSize * 1.53 );
      }

      //Write log
      var XmlRecord = "Text/";
      XmlRecord = XmlRecord + LC + "/" + TC + "/" + this.WSR + "/" + this.HSR +
        "/" + TempStr + "/" + this.fillColor + "/" + this.border + "/" +
        Size + "px " + Font;
      if ( this.toolName != "Text" ) { //Story and Headline
        var XmlRecord = "Text/";
        XmlRecord = XmlRecord + LC + "/" + TC + "/" + this.WSR + "/" + this
          .HSR + "/" + TempStr + "/" + this.fillColor + "/" +
          "1/18px Arial";
      }
      this.fillColor = oldColor;
      this.xmlLog.push( XmlRecord );

      //register this block position
      var registInfo = [];
      registInfo.push( LC ); //the left coordinate
      registInfo.push( TC ); //the top coordinate
      registInfo.push( this.WSR ); // the width
      registInfo.push( this.HSR ); //the height
      registInfo.push( TempStr ); //context
      registInfo.push( this.xmlLog.length );
      this.targetLogIndex = this.xmlLog.length;
      this.targetRegion.push( registInfo );
      this.canvasContext.strokeStyle = this.fillColor;
      this.canvasContext.lineWidth = this.border;
    } //End of "if" condition
    else if ( this.toolName == "Picture" ) {
      this.canvasContext.globalAlpha = 1;
      this.canvasContext.fillStyle = "White";
      this.canvasContext.fillRect( LC, TC, this.WSR, this.HSR );
      this.canvasContext.globalAlpha = 1;
      this.canvasContext.lineWidth = 1;
      this.canvasContext.strokeStyle = "Black";
      this.canvasContext.strokeRect( LC, TC, this.WSR, this.HSR );
      this.canvasContext.beginPath();
      this.canvasContext.moveTo( LC, TC );
      this.canvasContext.lineTo( LC + this.WSR, TC + this.HSR );
      this.canvasContext.moveTo( LC + this.WSR, TC );
      this.canvasContext.lineTo( LC, TC + this.HSR );
      this.canvasContext.stroke();
      this.canvasContext.textAlign = "center";
      this.canvasContext.strokeStyle = "Red";
      this.canvasContext.font = "18px Arial";
      this.canvasContext.strokeText( "Picture: " + TempStr, ( LC + LC +
        this.WSR ) / 2, ( TC + TC + this.HSR ) / 2 );

      //write log
      var XmlRecord = "Picture/" + LC + "/" + TC + "/" + this.WSR + "/" +
        this.HSR + "/" + TempStr;
      this.xmlLog.push( XmlRecord );

      //register block position
      var registInfo = [];
      registInfo.push( LC );
      registInfo.push( TC );
      registInfo.push( this.WSR );
      registInfo.push( this.HSR );
      registInfo.push( TempStr );
      registInfo.push( this.xmlLog.length );
      this.targetRegion.push( registInfo );
      this.canvasContext.strokeStyle = this.fillColor;
      this.canvasContext.lineWidth = this.border;
    } else if ( this.toolName == "Rectangle" ) {
      this.canvasContext.globalAlpha = 0.5;
      this.canvasContext.fillStyle = this.fillColor;
      this.canvasContext.fillRect( LC, TC, this.WSR, this.HSR );
      this.canvasContext.globalAlpha = 1;
      this.canvasContext.strokeStyle = "Red";
      this.canvasContext.strokeRect( LC, TC, this.WSR, this.HSR );

      //write log
      var XmlRecord = "Rectangle/";
      XmlRecord = XmlRecord + LC + "/" + TC + "/" + this.WSR + "/" + this.HSR +
        "/" + this.fillColor + "/" + this.border;
      this.xmlLog.push( XmlRecord );
    }
    this.xPos = null;
  }, // End of function "CanvasMouseUp"

  /**
   * @desc Clear all the markup on the page by reloading the image.
   */
  ClearMarkup: function() {
    if ( !confirm( "Are you sure you want to clear all markup?" ) ) {
      return;
    }
    var img = new Image();
    img.src = this.options.image;
    connect( img, "onload", this, function() {
      this.canvas.width = 612;
      this.canvasInfo = document.getElementById( "CanvasWithInfo" );
      this.canvasInfo.style.width = this.canvas.width + 6;
      this.canvas.height = 792;
      this.canvasContext.drawImage( img, 0, 0 );
    } );
    this.actionToolbar.getChild( "Undo" ).setEnabled( false );
    this.xmlLog = []; //Empty the log for xml
    var imageLog = "Image/" + this.imageName;
    this.xmlLog.push( imageLog );
    this.targetRegion = []; //Empty the annotation region;
  }, // End of function "ClearMarkup"

  /**
   * @desc Set FillColor
   * @param {string} colorId.
   */
  SetFillColor: function( colorId ) {
    var colorIdList = map( itemgetter( "id" ), this.colors );
    forEach( colorIdList, function( c ) {
      this.colorToolbar.getChild( c ).setChecked( c == colorId );
    }, this );
    this.colorName = colorId;
    this.fillColor = this.colorName;
    this.canvasContext.fillStyle = this.fillColor;
  }, // End of function "SetFillColor"

  selectFillColor: function( e ) {
    return this.SetFillColor( e.target.getId() );
  },

  PerformAction: function( e ) {
    switch ( e.target.getId() ) {
      case "Clear":
        this.ClearMarkup();
        break;
      case "Undo":
        this.Undo();
        break;
      case "Save":
        this.options.saveFunc();
        break;
    }
  },

  /**
   * @desc Set the markup Tool
   * @param {string} SomeTool Tool ID.
   */
  SetTool: function( toolId ) {
    /**
     * Make an id list of all of the markup tools.
     */
    var idList = map( itemgetter( "id" ), this.markupTools );

    /*
     * Ignore other events are not selected a markup tool
     */
    if ( findValue( idList, toolId ) != -1 ) {
      this.toolName = toolId;

      forEach( idList,
               function( m ) {
                 this.markupToolbar.getChild( m ).setChecked( m == toolId );
               }, this );
    }

    switch ( toolId ) {
      case "BorderSelect":
      this.border = this.markupToolbar.getChild( "BorderSelect" ).getValue();
        break;
      case "FontSelect":
      case "FontSize":
        this.FontOnChange();
        break;
      case "Text":
        this.markupToolbar.getChild( "FontSelect" ).setEnabled( true );
        this.markupToolbar.getChild( "FontSize" ).setEnabled( true );
//        document.getElementById( "Font" ).style.visibility = "visible";
//        document.getElementById( "Size" ).style.visibility = "visible";
        break;
      case "Pointer":
        this.canvas.style.cursor = "default";
        break;
    }

    if ( this.toolName != "Text" ) {
      this.markupToolbar.getChild( "FontSelect" ).setEnabled( false );
      this.markupToolbar.getChild( "FontSize" ).setEnabled( false );
//        document.getElementById( "Font" ).style.visibility = "hidden";
//        document.getElementById( "Size" ).style.visibility = "hidden";
        this.canvas.style.cursor = "crosshair";
    }
  }, // End of function "SetTool"

  selectMarkupTool: function( e ) {
    return this.SetTool( e.target.getId() );
  },

  /**
   *@desc Undo the markup step by step.
   *      The idea is to pop out the last log in markup log array,
   *      then re-generate the markup on page.
   */
  Undo: function() {
    var undoButton = this.actionToolbar.getChild( "Undo" );
    if ( this.xmlLog.length <= 2 ) {
      undoButton.setEnabled( false );
      this.targetRegion.pop();
      var record = "<Markup></Markup>"
      this.GenerateMarkup( this.canvasContext, record, false );
      var XmlRecord = this.xmlLog.pop().split( "/" );
      if ( XmlRecord[ 0 ] == "Pencil" ) {
        var FirstRecord = this.xmlLog[ 0 ];
        this.xmlLog = [];
        this.xmlLog.push( FirstRecord );
      }
      return;
    }
    var XmlRecord = this.xmlLog.pop().split( "/" );
    if ( XmlRecord[ 0 ] == "Pencil" ) {
      while ( XmlRecord[ 1 ] != "Start" ) {
        XmlRecord = this.xmlLog.pop().split( "/" );
      }
    } else if ( XmlRecord[ 0 ] == "Text" || XmlRecord[ 0 ] == "Picture" ) {
      this.targetRegion.pop();
    }
    var XmlText = this.GenerateXml( this.xmlLog );
    this.GenerateMarkup( this.canvasContext, XmlText, false );

  }, // End of function "Undo"

  /**
   * @desc Returns a base 64 encoded JPEG of the canvas.
   * @param? type {string="image/jpeg"} The image type.
   * @return {string} The
   */
  getJPEG: function( type ) {
    //Get Current Data URL
    type = isUndefinedOrNull( type ) ? "image/jpeg" : type;
    return this.canvas.toDataURL( type );
  }, //End of function "SaveJPEG"


  /**
   *@desc  This function will use the xml string and canvascontext to
   *       create the markup on the canvas.
   *@param {CanvasContext} ctx the HTML5 canvas object.
   *@param {string} XmlText the xml string that contain all the markup information in it.
   *@param {boolean} refresh If true, the browser will fetch image from the back end,
   *                 otherwise not.
   *
   */
  GenerateMarkup: function( ctx, XmlText, refresh ) {
    //Draw the Image
    var img = new Image();
    var textWrapFunc = this.TextWrap;

    if ( window.DOMParser ) {
      parser = new DOMParser();
      xmlDoc = parser.parseFromString( XmlText, "text/xml" );
    }
    img.src = this.options.image;

    if ( refresh ) {
      //force the browser to refresh the image.
      img.src = this.options.image + "&timestamp=" + new Date().getTime();
      this.options.image = img.src;
    }
    ctx.font = "18px Arial";
    ctx.strokeStyle = "Red";
    ctx.textAligh = "start";

    img.onload = function() {
      ctx.drawImage( img, 0, 0 );
      var MarkupNumber = xmlDoc.childNodes[ 0 ].childNodes.length;
      var index;
      for ( index = 1; index < MarkupNumber; index++ ) {
        var NodeName = xmlDoc.childNodes[ 0 ].childNodes[ index ].nodeName;
        if ( NodeName == "Approved" ) {
          var xPos = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "X" )[ 0 ].textContent;
          var yPos = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Y" )[ 0 ].textContent;
          ctx.fillStyle = "Green";
          ctx.font = "18px Arial";
          TempChr = "\u2713";
          ctx.fillText( TempChr, xPos, yPos );
        } //END OF "IF" CONDITION
        else if ( NodeName == "Rejected" ) {
          var xPos = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "X" )[ 0 ].textContent;
          var yPos = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Y" )[ 0 ].textContent;
          ctx.fillStyle = "Red";
          ctx.font = "18px Arial";
          TempChr = "X";
          ctx.fillText( TempChr, xPos, yPos );
        } //END OF "IF"CONDITION
        else if ( NodeName == "Arrow" ) {
          var XC = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "XC" )[ 0 ].textContent;
          var YC = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "YC" )[ 0 ].textContent;
          var XCW = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "XCW" )[ 0 ].textContent;
          var YCH = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "YCH" )[ 0 ].textContent;
          var width = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Width" )[ 0 ].textContent;
          var Color = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Color" )[ 0 ].textContent;
          ctx.beginPath();
          var headlen = 10;
          var dx = XCW - XC;
          var dy = YCH - YC;
          var angle = Math.atan2( dy, dx );
          ctx.lineWidth = width;
          ctx.strokeStyle = Color;
          ctx.moveTo( XC, YC );
          ctx.lineTo( XCW, YCH );
          ctx.moveTo( XCW - headlen * Math.cos( angle - Math.PI / 6 ),
            YCH - headlen * Math.sin( angle - Math.PI / 6 ) );
          ctx.lineTo( XCW, YCH );
          ctx.lineTo( XCW - headlen * Math.cos( angle + Math.PI / 6 ),
            YCH - headlen * Math.sin( angle + Math.PI / 6 ) );
          ctx.stroke();
        } //END OF IF CONDITION
        else if ( NodeName == "Line" ) {
          var XC = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "XC" )[ 0 ].textContent;
          var YC = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "YC" )[ 0 ].textContent;
          var XCW = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "XCW" )[ 0 ].textContent;
          var YCH = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "YCH" )[ 0 ].textContent;
          var width = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Width" )[ 0 ].textContent;
          var Color = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Color" )[ 0 ].textContent;
          ctx.lineWidth = width;
          ctx.strokeStyle = Color;
          ctx.beginPath();
          ctx.moveTo( XC, YC );
          ctx.lineTo( XCW, YCH );
          ctx.stroke();
        } //END OF IF CONDITION
        else if ( NodeName == "Oval" ) {
          //console.log("oval");
          var LC = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "LC" )[ 0 ].textContent );
          var TC = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "TC" )[ 0 ].textContent );
          var WSR = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "WSR" )[ 0 ].textContent );
          var HSR = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "HSR" )[ 0 ].textContent );
          var Color = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Color" )[ 0 ].textContent;
          var width = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Width" )[ 0 ].textContent;
          ctx.lineWidth = width;
          ctx.beginPath();
          ctx.moveTo( LC + ( WSR / 2 ), TC );
          ctx.quadraticCurveTo( LC + WSR, TC,
            LC + WSR, TC + ( HSR / 2 ) );
          ctx.quadraticCurveTo( LC + WSR, TC + HSR,
            LC + ( WSR / 2 ), TC + HSR );
          ctx.quadraticCurveTo( LC, TC + HSR,
            LC, TC + ( HSR / 2 ) );
          ctx.quadraticCurveTo( LC, TC,
            LC + ( WSR / 2 ), TC );
          ctx.globalAlpha = 0.5;
          ctx.fillStyle = Color;
          ctx.fill();
          ctx.globalAlpha = 1;
          ctx.strokeStyle = "Red";
          ctx.stroke();
        } //END OF "IF" CONDITION
        else if ( NodeName == "Pencil" ) {
          var info = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Position" );
          var width = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Width" )[ 0 ].textContent;
          var Color = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Color" )[ 0 ].textContent;
          ctx.lineWidth = width;
          ctx.strokeStyle = Color;
          for ( var index2 = 0; index2 < info.length; index2++ ) {
            var data = info[ index2 ].textContent.split( "/" );
            var XC = data[ 0 ];
            var YC = data[ 1 ];
            var XCW = data[ 2 ];
            var YCH = data[ 3 ];
            ctx.beginPath();
            ctx.moveTo( XC, YC );
            ctx.lineTo( XCW, YCH );
            ctx.stroke();
          }
        } //END OF "IF" CONDITION
        else if ( NodeName == "Rectangle" ) {
          var LC = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "LC" )[ 0 ].textContent;
          var TC = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "TC" )[ 0 ].textContent;
          var WSR = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "WSR" )[ 0 ].textContent;
          var HSR = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "HSR" )[ 0 ].textContent;
          var Color = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Color" )[ 0 ].textContent;
          var width = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Width" )[ 0 ].textContent;
          ctx.globalAlpha = 0.5;
          ctx.fillStyle = Color;
          ctx.fillRect( LC, TC, WSR, HSR );
          ctx.globalAlpha = 1;
          ctx.lineWidth = width;
          ctx.strokeStyle = "Red";
          ctx.strokeRect( LC, TC, WSR, HSR );
        } //END OF "IF" CONDITION
        else if ( NodeName == "Text" ) {

          var LC = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "LC" )[ 0 ].textContent );
          var TC = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "TC" )[ 0 ].textContent );
          var WSR = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "WSR" )[ 0 ].textContent );
          var HSR = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "HSR" )[ 0 ].textContent );
          var Color = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Color" )[ 0 ].textContent;
          var Width = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Width" )[ 0 ].textContent;
          var TempStr = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Content" )[ 0 ].textContent;
          var Font = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Font" )[ 0 ].textContent
          ctx.globalAlpha = 0.5;
          ctx.fillStyle = Color;
          ctx.fillRect( LC, TC, WSR, HSR );
          ctx.globalAlpha = 1;
          ctx.lineWidth = Width;
          ctx.strokeStyle = Color;
          ctx.strokeRect( LC, TC, WSR, HSR );
          FontSize = parseFloat( Font.substring( 0, 2 ) );
          var Text = textWrapFunc( WSR, TempStr, FontSize );
          ctx.font = Font;
          ctx.textAlign = "start";
          ctx.strokeStyle = "Red";
          wrap = 0;
          for ( index2 = 0; index2 < Text.length; index2++ ) {
            ctx.strokeText( Text[ index2 ], LC + 5, TC + FontSize + wrap );
            wrap = wrap + ( FontSize * 1.53 );
          }

        } //END OF "IF" CONDITION
        else if ( NodeName == "Picture" ) {
          var LC = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "LC" )[ 0 ].textContent );
          var TC = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "TC" )[ 0 ].textContent );
          var WSR = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "WSR" )[ 0 ].textContent );
          var HSR = parseInt( xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "HSR" )[ 0 ].textContent );
          var TempStr = xmlDoc.childNodes[ 0 ].childNodes[ index ].getElementsByTagName(
            "Content" )[ 0 ].textContent;
          ctx.globalAlpha = 1;
          ctx.fillStyle = "White";
          ctx.fillRect( LC, TC, WSR, HSR );
          ctx.beginPath();
          ctx.globalAlpha = 1;
          ctx.lineWidth = 1;
          ctx.strokeStyle = "Black";
          ctx.strokeRect( LC, TC, WSR, HSR );
          ctx.moveTo( LC, TC );
          ctx.lineTo( LC + WSR, TC + HSR );
          ctx.moveTo( LC + WSR, TC );
          ctx.lineTo( LC, TC + HSR );
          ctx.stroke();
          ctx.textAlign = "center";
          ctx.strokeStyle = "Red";
          ctx.font = "18px Arial";
          var text = "Picture: " + TempStr;
          ctx.strokeText( text, ( LC + LC + WSR ) / 2, ( TC + TC + HSR ) /
            2 );
        }
      } //END OF FOR LOOP
    }; //END IMAGE ONLOAD FUNCTION
  }, //END OF FUNCTION "GenerateMarkup"

  /**
   *@desc This function could set the opacity of Color.
   */
  SelectOpacity: function() {
    var slider = document.getElementById( "OpacitySlider" );
    var rate = slider.value / 100;
    var HexFillColor = goog.color.parse( this.colorName );
    var RGBColor = goog.color.hexToRgb( HexFillColor.hex );
    if ( rate >= 1 ) {
      var NewColor = goog.color.darken( RGBColor, rate - 1 );
      this.fillColor = goog.color.rgbArrayToHex( NewColor );
    } else {
      var NewColor = goog.color.lighten( RGBColor, 1 - rate );
      this.fillColor = goog.color.rgbArrayToHex( NewColor );
    }
  }, //END OF FUNCTION "selectOpacity"


  /**
   *@desc Check whether mouse is over some block area.
   *      In this method, it will search the TargetRegion to find out the result.
   *@param  {int} x the x coordinate of the mouse
   *@param  {int} y the y coordiante of the mouse
   *@return {int} if return -1, it means mouse is not over any block area.
   *              otherwise, it will return the index of this block area in TargetRegion.
   */
  CheckRegion: function( x, y ) { //Check whether mouse is on the top of text box
    var index;
    for ( index = this.targetRegion.length - 1; index >= 0; index-- ) {
      var lc = this.targetRegion[ index ][ 0 ]; //x position of left top corner
      var tc = this.targetRegion[ index ][ 1 ]; //y position of left top corner
      var wsr = this.targetRegion[ index ][ 2 ]; //width
      var hsr = this.targetRegion[ index ][ 3 ]; //height
      if ( ( x > lc && x < ( lc + wsr ) ) && ( y > tc && y < tc + hsr ) ) {
        if ( x < ( lc + wsr ) && x > ( lc + wsr - 15 ) && y > ( tc + hsr -
            15 ) && y < ( tc + hsr ) ) {
          this.resize = true;
          //change the mouse style
          this.canvas.style.cursor = "se-resize";
        }
        return index;

      }
    }
    return -1;
  }, //End of function "CheckRegion"


  /**
   *@desc  This function is used to wrap the text
   *@param {int} Width the width of the block area
   *@param {string} Content the text itself.
   *@param {int} FontSize the font size.
   *@return {Array} contains the text that been wrapped. One array cell is one line.
   *@example
   * var text = "Delete this ads."
   * //we assume that one line could only have 13 letters.
   * var arr = [ {Delete this}, {ads}];
   */
  TextWrap: function( Width, Content, FontSize ) {
    var Text = [];
    var contentArray = Content.split( " " );
    if ( contentArray.length == 1 ) {
      return contentArray;
    }
    var show = "";
    var TestString = "";
    for ( index = 0; index < contentArray.length; index++ ) {
      TestString = show + contentArray[ index ];
      if ( ( TestString.length ) * ( FontSize / 1.5 ) < Width ) {
        show = show + contentArray[ index ] + " ";
      } else { //wrap
        Text.push( show );
        show = contentArray[ index ] + " ";
      }
    }
    if ( show.length != 0 ) {
      Text.push( show );
    }
    return Text;
  }, //END OF FUNCTION "TextWrap"

  /**
   *@desc Change the mouse style and target status tag.
   *
   */
  SelectTarget: function() {
    this.targetStatus = true;
    if ( this.resize ) {
      this.canvas.style.curse = "se-resize";
    } else {
      this.canvas.style.cursor = "move";
    }
    this.targetLogIndex = this.targetRegion[ this.target ][ 5 ];
  },

  /**
   * @desc Resizing and dragging the target on the canvas.
   *       This function get the coordinate of the current mouse position and
   *       update the xml log.
   *       Then call GenerateMarkup method to re-generate the markup on the canvas.
   * @param {int} x the x coordinate of the current mouse position.
   * @param {int} y the y coordinate of the current mouse position.
   */
  MoveTarget: function( x, y ) {
    //reset the target
    //reset the checkregion
    var record = this.xmlLog[ this.targetLogIndex - 1 ].split( "/" );
    if ( this.resize ) { //resizing the block
      if ( this.snap ) {
        if ( x > record[ 1 ] ) { //resize towards right
          moveDirection = 0;
          for ( index = moveDirection; index < this.column.length; index +=
            2 ) {
            if ( x < this.column[ index ] && x + this.snapDistance >= this.column[
                index ] ) {
              x = parseInt( this.column[ index ] );
            } else if ( x - this.snapDistance <= this.column[ index ] && x >
              this.column[ index ] ) {
              x = parseInt( this.column[ index ] );
            }
          } //End of FOR Loop
        } else { //resize towards left
          moveDirection = 1;
          for ( index = moveDirection; index < this.column.length; index +=
            2 ) {
            if ( x > this.column[ index ] && x - this.snapDistance <= this.column[
                index ] ) {
              x = parseInt( this.column[ index ] );
            } else if ( x + this.snapDistance >= this.column[ index ] && x <
              this.column[ index ] ) {
              x = parseInt( this.column[ index ] );
            }
          } //End of FOR Loop
        } //End of If Condition
      } //End of if Condition

      this.targetRegion[ this.target ][ 2 ] = x - record[ 1 ];
      this.targetRegion[ this.target ][ 3 ] = y - record[ 2 ];
      var newRecord = record[ 0 ] + "/" + record[ 1 ] + "/" + record[ 2 ] +
        "/" + ( x - record[ 1 ] ) + "/" + ( y - record[ 2 ] ) + "/" +
        record[ 5 ] + "/";
      if ( record[ 0 ] == "Text" ) {
        var newRecord = record[ 0 ] + "/" + record[ 1 ] + "/" + record[ 2 ] +
          "/" + ( x - record[ 1 ] ) + "/" + ( y - record[ 2 ] ) + "/" +
          record[ 5 ] + "/" + record[ 6 ] + "/" + record[ 7 ] + "/" +
          record[ 8 ];
      }
    } else {
      //moving target
      if ( this.snap ) {
        for ( index = 1; index < this.column.length; index += 2 ) {
          //make the left border of box snap to the right side of column
          if ( x < this.column[ index ] && x + this.snapDistance >= this.column[
              index ] ) {
            x = parseInt( this.column[ index ] );
            break;
          } else if ( x > this.column[ index ] && x - this.snapDistance <
            this.column[ index ] ) {
            x = parseInt( this.column[ index ] );
            break;
          }
        } //End of "for" loop

        for ( index = 0; index < this.column.length; index += 2 ) {
          //make the left border of box snap to the right side of column
          if ( x + parseInt( record[ 3 ] ) < this.column[ index ] &&
            x + this.snapDistance + parseInt( record[ 3 ] ) >= this.column[
              index ] ) {
            x = this.column[ index ] - parseInt( record[ 3 ] );
            break;
          } else if ( x + parseInt( record[ 3 ] ) > this.column[ index ] &&
            x - this.snapDistance + parseInt( record[ 3 ] ) < this.column[
              index ] ) {
            x = this.column[ index ] - parseInt( record[ 3 ] );
            break;
          }
        } //End of "for" looop
      } //End of "if" condition

      if ( record[ 0 ] == "Picture" ) {
        this.targetRegion[ this.target ][ 0 ] = x;
        this.targetRegion[ this.target ][ 1 ] = y;
        var newRecord = record[ 0 ] + "/" + x + "/" + y + "/" + record[ 3 ] +
          "/" + record[ 4 ] + "/" + record[ 5 ];
      } else {
        this.targetRegion[ this.target ][ 0 ] = x;
        this.targetRegion[ this.target ][ 1 ] = y;
        var newRecord = record[ 0 ] + "/" + x + "/" + y + "/" + record[ 3 ] +
          "/" + record[ 4 ] + "/" + record[ 5 ] + "/" + record[ 6 ] + "/" +
          record[ 7 ] + "/" + record[ 8 ];
      } //End of "if" condition
    } //End of "if" condition

    this.xmlLog[ this.targetLogIndex - 1 ] = newRecord;

    //reset the xmllog
    XmlText = this.GenerateXml( this.xmlLog );
    this.GenerateMarkup( this.canvasContext, XmlText, false );

  }, //END OF FUNCTION "MoveTarget"

  /**
   *@desc This function will be called after user finish resizing or dragging
   *      the target. it reset the TargetStatus and Target.
   *
   */
  ReleaseTarget: function() {
    this.targetStatus = false;
    this.target = -1;
    if ( this.toolName != "Pointer" ) {
      this.canvas.style.cursor = "crosshair";
    } else {
      this.canvas.style.cursor = "default";
    }
    if ( this.resize ) {
      this.resize = false;
    }
  },

  /**
   * @desc This function will called if the font and size settings are changed.
   */
  FontOnChange: function() {
    var font = this.markupToolbar.getChild( "FontSelect" ).getValue();
    var size = this.markupToolbar.getChild( "FontSize" ).getValue();
    this.canvasContext.font = size + "px " + font;
    var record = this.xmlLog[ this.targetLogIndex - 1 ].split( "/" );

    if ( record[ 0 ] == "Text" ) {
      var index;
      var TextInfo = "";
      for ( index = 0; index < record.length; index++ ) {
        if ( index == 8 ) { //Font Record
          record[ index ] = size + "px " + font;
          TextInfo = TextInfo + record[ index ];
          break;
        }
        TextInfo = TextInfo + record[ index ] + "/";
      }
      this.xmlLog[ this.targetLogIndex - 1 ] = TextInfo;
      XmlText = this.GenerateXml( this.xmlLog );
      this.GenerateMarkup( this.canvasContext, XmlText, false );
      //Redraw the text box on the page
    }
  }, //END OF FUNCTION "FontOnChange"

  /**
   *@desc Change the content of block area, such as picture template,
   *      story template, headline template and text box.
   *@param {object} event the page event object
   *
   */
  ChangeContent: function( event ) {
    if ( this.toolName == "Pointer" ) {
      var x = event.pageX - this.canvasRect.left + 1;
      var y = event.pageY - this.canvasRect.top + 1;
      this.target = this.CheckRegion( x, y );

      if ( this.target >= 0 ) {
        //select a Target
        this.targetLogIndex = this.targetRegion[ this.target ][ 5 ];
        var tag = this.targetRegion[ this.target ][ 4 ];
        var TempStr = prompt( "New Content:", this.targetRegion[ this.target ]
          [ 4 ] );
        if ( tag[ 0 ] == "S" ) {
          TempStr = "Story: " + TempStr;
        } else if ( tag[ 0 ] == "H" ) {
          TempStr = "Headline: " + TempStr;
        }
        if ( TempStr != null && TempStr != "" ) {
          this.targetRegion[ this.target ][ 4 ] = TempStr;
          var record = this.xmlLog[ this.targetLogIndex - 1 ].split( "/" );
          var index;
          var newRecord = "";
          for ( index = 0; index < record.length; index++ ) {
            newRecord = newRecord + record[ index ] + "/";
            if ( index == 4 ) {
              record[ index + 1 ] = TempStr;
            }
          }
          this.xmlLog[ this.targetLogIndex - 1 ] = newRecord;
          XmlText = this.GenerateXml( this.xmlLog );
          this.GenerateMarkup( this.canvasContext, XmlText, false );
        } //END OF "IF" CONDITION
      } //END OF "IF" CONDITION
      this.canvas.style.cursor = "default";
    } //END OF "IF" CONDITION
  }, //END OF FUNCTION "ChangeContent"



  /**
   *@desc  Parse the markup log array to a xml string.
   *       When adding a new markup tool, you should add code to tell this method
   *       how to parse the new markup log.
   *@param {Array} Xmllog  the array that contains the markup log.
   *@return {string} the markup log in a xml string formate
   *
   *@example
   * var xmllog = [{"image/0"},{"approved/100/100"},{"arrow/100/100/200/200/Black/3"}]
   * var return = "<Markup>
   *                <Image><Src>0</Src></Image>
   *                <Approved><X>100</X><Y>100</Y></Approved>
   *                <Arrow>
   *                      <XC>100</XC><YC>100</YC><XCW>200</XCW>
   *                      <YCH>200</YCH><Color>Black</Color>
   *                      <Width>3</Width>
   *                </Arrow>
   *              </Markup>"
   */

  GenerateXml: function( xmlLog ) {
    if ( xmlLog.length == 1 ) {
      XmlText = "";
      return XmlText;
    }
    XmlText = "<Markup>";

    for ( index = 0; index < xmlLog.length; index++ ) {
      var record = xmlLog[ index ].split( "/" );

      if ( record[ 0 ] == "Image" ) {
        XmlText = XmlText + "<Image>";
        XmlText = XmlText + "<Src>" + record[ 1 ] + "</Src>";
        XmlText = XmlText + "</Image>";
      } else if ( record[ 0 ] == "Approved" ) {
        XmlText = XmlText + "<Approved>";
        XmlText = XmlText + "<X>" + record[ 1 ] + "</X>";
        XmlText = XmlText + "<Y>" + record[ 2 ] + "</Y>";
        XmlText = XmlText + "</Approved>";
      } else if ( record[ 0 ] == "Rejected" ) {
        XmlText = XmlText + "<Rejected>";
        XmlText = XmlText + "<X>" + record[ 1 ] + "</X>";
        XmlText = XmlText + "<Y>" + record[ 2 ] + "</Y>";
        XmlText = XmlText + "</Rejected>";
      } else if ( record[ 0 ] == "Arrow" ) {
        XmlText = XmlText + "<Arrow>";
        XmlText = XmlText + "<XC>" + record[ 1 ] + "</XC>";
        XmlText = XmlText + "<YC>" + record[ 2 ] + "</YC>";
        XmlText = XmlText + "<XCW>" + record[ 3 ] + "</XCW>";
        XmlText = XmlText + "<YCH>" + record[ 4 ] + "</YCH>";
        XmlText = XmlText + "<Color>" + record[ 5 ] + "</Color>";
        XmlText = XmlText + "<Width>" + record[ 6 ] + "</Width>";
        XmlText = XmlText + "</Arrow>";
      } else if ( record[ 0 ] == "Line" ) {
        XmlText = XmlText + "<Line>";
        XmlText = XmlText + "<XC>" + record[ 1 ] + "</XC>";
        XmlText = XmlText + "<YC>" + record[ 2 ] + "</YC>";
        XmlText = XmlText + "<XCW>" + record[ 3 ] + "</XCW>";
        XmlText = XmlText + "<YCH>" + record[ 4 ] + "</YCH>";
        XmlText = XmlText + "<Color>" + record[ 5 ] + "</Color>";
        XmlText = XmlText + "<Width>" + record[ 6 ] + "</Width>";
        XmlText = XmlText + "</Line>";
      } else if ( record[ 0 ] == "Oval" ) {
        XmlText = XmlText + "<Oval>";
        XmlText = XmlText + "<LC>" + record[ 1 ] + "</LC>";
        XmlText = XmlText + "<TC>" + record[ 2 ] + "</TC>";
        XmlText = XmlText + "<WSR>" + record[ 3 ] + "</WSR>";
        XmlText = XmlText + "<HSR>" + record[ 4 ] + "</HSR>";
        XmlText = XmlText + "<Color>" + record[ 5 ] + "</Color>";
        XmlText = XmlText + "<Width>" + record[ 6 ] + "</Width>";
        XmlText = XmlText + "</Oval>";
      } else if ( record[ 0 ] == "Rectangle" ) {
        XmlText = XmlText + "<Rectangle>";
        XmlText = XmlText + "<LC>" + record[ 1 ] + "</LC>";
        XmlText = XmlText + "<TC>" + record[ 2 ] + "</TC>";
        XmlText = XmlText + "<WSR>" + record[ 3 ] + "</WSR>";
        XmlText = XmlText + "<HSR>" + record[ 4 ] + "</HSR>";
        XmlText = XmlText + "<Color>" + record[ 5 ] + "</Color>";
        XmlText = XmlText + "<Width>" + record[ 6 ] + "</Width>";
        XmlText = XmlText + "</Rectangle>";
      } else if ( record[ 0 ] == "Text" ) {
        XmlText = XmlText + "<Text>";
        XmlText = XmlText + "<LC>" + record[ 1 ] + "</LC>";
        XmlText = XmlText + "<TC>" + record[ 2 ] + "</TC>";
        XmlText = XmlText + "<WSR>" + record[ 3 ] + "</WSR>";
        XmlText = XmlText + "<HSR>" + record[ 4 ] + "</HSR>";
        XmlText = XmlText + "<Color>" + record[ 6 ] + "</Color>";
        XmlText = XmlText + "<Content>" + record[ 5 ] + "</Content>";
        XmlText = XmlText + "<Width>" + record[ 7 ] + "</Width>";
        XmlText = XmlText + "<Font>" + record[ 8 ] + "</Font>";
        XmlText = XmlText + "</Text>";
      } else if ( record[ 0 ] == "Annotation" ) {
        XmlText = XmlText + "<Annotation>";
        XmlText = XmlText + "<LC>" + record[ 1 ] + "</LC>";
        XmlText = XmlText + "<TC>" + record[ 2 ] + "</TC>";
        XmlText = XmlText + "<WSR>" + record[ 3 ] + "</WSR>";
        XmlText = XmlText + "<HSR>" + record[ 4 ] + "</HSR>";
        XmlText = XmlText + "<Color>" + record[ 6 ] + "</Color>";
        XmlText = XmlText + "<Content>" + record[ 5 ] + "</Content>";
        XmlText = XmlText + "<Width>" + record[ 7 ] + "</Width>";
        XmlText = XmlText + "</Annotation>";
      } else if ( record[ 0 ] == "Pencil" ) {
        XmlText = XmlText + "<Pencil>";
        index = index + 1; //move the index
        record = xmlLog[ index ].split( "/" );
        while ( record[ 0 ] == "Pencil" ) {
          if ( record.length == 3 ) {
            XmlText = XmlText + "<Color>" + record[ 1 ] + "</Color>";
            XmlText = XmlText + "<Width>" + record[ 2 ] + "</Width>";
            index = index + 1;
            record = xmlLog[ index ].split( "/" );
            continue;
          } else if ( record[ 1 ] == "End" ) {
            XmlText = XmlText + "</Pencil>";
            break;
          }
          XmlText = XmlText + "<Position>" + record[ 1 ] + "/" + record[ 2 ] +
            "/" + record[ 3 ] + "/" + record[ 4 ] + "</Position>";
          index = index + 1;
          record = xmlLog[ index ].split( "/" );
        }
      } else if ( record[ 0 ] == "Picture" ) {
        XmlText = XmlText + "<Picture>";
        XmlText = XmlText + "<LC>" + record[ 1 ] + "</LC>";
        XmlText = XmlText + "<TC>" + record[ 2 ] + "</TC>";
        XmlText = XmlText + "<WSR>" + record[ 3 ] + "</WSR>";
        XmlText = XmlText + "<HSR>" + record[ 4 ] + "</HSR>";
        XmlText = XmlText + "<Content>" + record[ 5 ] + "</Content>";
        XmlText = XmlText + "</Picture>";
      }
    }
    XmlText = XmlText + "</Markup>";
    return XmlText;
  }
};

//END OF THE FILE
